import { ExtendedAccountColumns, ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { ReadonlyStorageAppContext } from '@juvare/platform-app/App';
import { ReadonlyStorageBackendApi } from '@juvare/platform-app/Storage';
import { AppState } from '@juvare/platform-sdk-react/types';

export function getReadonlyExtendedAccountStorage(
    context: ReadonlyStorageAppContext<AppState>,
): ReadonlyStorageBackendApi<ExtendedAccountData, ExtendedAccountColumns> {
    return context.storage<ExtendedAccountData, ExtendedAccountColumns>(accountEntityName);
}
